import React from 'react';
import { cn } from '../../lib/cn';
import type { FormListStatus } from '../../forms/types';

const statusStyles: Record<FormListStatus, string> = {
  published: 'bg-[var(--success-tint)] text-[var(--success)]',
  draft: 'bg-[var(--cream-0)] text-[var(--ink-3)]',
  archived: 'bg-[var(--terracotta-tint)] text-[var(--terracotta)]',
};

export interface FormsStatusPillProps {
  status: FormListStatus;
}

export function FormsStatusPill({ status }: FormsStatusPillProps) {
  return (
    <span
      className={cn(
        'inline-flex rounded-[var(--r-pill)] px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide w-fit',
        statusStyles[status]
      )}
    >
      {status}
    </span>
  );
}
